<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-tag"></i>
                <span>{{$t('document_template.choice_tags')}}</span>
            </h2>
        </div>
        <div class="panel__body">
            <div class="row">
                <div class="col-12">
                    <ul class="tags">
                        <li v-for="tag in filteredTags">
                            <a class="tags__tag" @click.prevent="insert(tag)" v-tooltip="tag.description">
                                <span class="tags__tag__close" @click.prevent="remove(tag)">
                                    <i class="mdi mdi-close"></i>
                                </span>
                                <code>{{tag.name}} - {{tag.configuration.map(i => i.text).join(', ')}}</code>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <form @submit.prevent="submit"
                          class="form">
                        <div class="form__item">
                            <i class="form__icon icons icon-user"></i>
                            <input type="text"
                                   v-model="name"
                                   @blur="convertName"
                                   :class="['form__input--text', {'has-value': name}]"/>
                            <label class="form__label">
                                {{$t('forms.document_template.tag_name')}}
                            </label>
                        </div>
                        <div class="form__item">
                            <i class="form__icon icons icon-info"></i>
                            <input type="text"
                                   v-model="description"
                                   :class="['form__input--text', {'has-value': description}]"/>
                            <label class="form__label">
                                {{$t('forms.document_template.tag_description')}}
                            </label>
                        </div>
                        <div v-for="item in listOptions" :key="item.id" class="form__item--removable">
                            <input type="text"
                                   v-model="item.text"
                                   :class="['form__input--text', {'has-value': item.text}]"/>
                            <label class="form__label">
                                {{$t('forms.document_template.tag_value')}}
                            </label>
                            <span class="button--alt form__item__button_remove" @click.prevent="removeOption(item)"><i class="mdi mdi-close"></i></span>
                        </div>
                        <div class="form__buttons">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <button type="button" @click.prevent="add"
                                            class="form__button button--alt">
                                        {{$t('common.add')}}
                                    </button>
                                </div>
                                <div class="col-12 col-md-6">
                                    <button type="submit" :disabled="!accepted"
                                            class="form__button button--cta" :class="{disabled: !accepted}">
                                        {{$t('common.save')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop, Watch} from 'vue-property-decorator';
    import slugify from 'slugify';
    import {DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE} from '@/store/modules/document-template-tags';
    import uuid from 'uuid/v4';

    @Component
    export default class ChoiceTags extends Vue {
        name = '';
        description = '';
        listOptions = [];

        created() {
            this.clearForm();
        }

        @Prop({type: Array, default: () => ([])})
        tags;

        get filteredTags() {
            return this.tags.filter(field => field.type === DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE);
        }

        get validListOptions() {
            return this.listOptions.filter(option => option.text && option.text.length);
        }

        get accepted() {
            if (this.validListOptions.length < 2) return false;
            const event = {
                name: this.name,
                accepted: true,
            };
            this.$emit('validate', event);
            return event.accepted;
        }

        submit() {
            this.convertName();
            if (this.accepted) {
                const tag = {
                    type: DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE,
                    name: this.name,
                    description: this.description,
                    configuration: this.validListOptions,
                };
                this.tags.push(tag);
                this.clearForm();
            }
        }

        clearForm() {
            this.name = '';
            this.description = '';
            this.listOptions = [];
            this.add();
            this.add();
        }

        @Watch('validListOptions')
        onLastTextFilled(value) {
            const last = this.listOptions[this.listOptions.length - 1];
            if (this.validListOptions.includes(last)) {
                this.add();
            }
        }

        add() {
            const key = uuid();
            this.listOptions.push({
                id: uuid(),
                text: '',
            });
        }

        removeOption(item) {
            const index = this.listOptions.indexOf(item);
            if (index > -1) {
                this.listOptions.splice(index, 1);
            }
        }

        editExisting(tag) {
            const index = this.tags.indexOf(tag);
            if (index > -1) {
                this.tags.splice(index, 1);
            }
            this.name = tag.name;
            this.description = tag.description;
            this.listOptions = tag.configuration;
        }

        insert(tag) {
            this.$emit('insert', tag);
        }

        remove(tag) {
            const index = this.tags.indexOf(tag);
            if (index > -1) {
                this.tags.splice(index, 1);
            }
        }

        convertName() {
            this.name = slugify(this.name.toLowerCase());
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/document-templates/ChoiceTagForm.vue